import { useQuery } from "@tanstack/react-query";
import { DevourPlayApi, Token } from "@devour/client";
import getConfig from "@/utils/getConfig";

export type TimeFilter = "day" | "week" | "month" | "year" | "all" | "custom";

export interface FuelTransactionHistoryItem {
    id: string;
    fiatAmount: number;
    fiatAmountFormatted: string;
    fuelAmount: number;
    type: "DEBIT" | "CREDIT";
    subject: string;
    description: string;
    createdAt: string;
}

export interface FuelTransactionHistoryResponse {
    transactions: FuelTransactionHistoryItem[];
    pagination: {
        total: number;
        limit: number;
        offset: number;
        hasMore: boolean;
    };
    timeFilter: string;
    startDate: string;
    endDate: string;
}

interface UseGetTransactionHistoryFuelParams {
    timeFilter?: TimeFilter;
    enabled?: boolean;
}

export const useGetTransactionHistoryFuel = (
    fullToken: Token | undefined,
    params: UseGetTransactionHistoryFuelParams = {},
) => {
    const { timeFilter = "all", enabled = true } = params;

    return useQuery({
        queryKey: ["transaction-history-fuel-v1", fullToken?.token || "anonymous", timeFilter],
        queryFn: async () => {
            if (!fullToken?.token) {
                throw new Error("No authentication token");
            }
            return new DevourPlayApi(getConfig(fullToken)).getDevourplayTransactionHistoryFuel({
                timeFilter: timeFilter as any,
            });
        },
        enabled: enabled && !!fullToken?.token,
        staleTime: 1000 * 60 * 2, // Cache for 2 minutes per timeFilter
        gcTime: 1000 * 60 * 10, // Keep in memory for 10 minutes
        refetchOnWindowFocus: false,
        retry: 2,
    });
};